import ReactDOM from 'react-dom/client';
import 'maplibre-gl/dist/maplibre-gl.css';
import '@/styles/global.css';
import '@/styles/material-symbols.css';
import { App } from './App';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <App />,
);
